import React, {useState, useEffect} from 'react';
import { CollapseIcon } from '../appearance/icons/collapse_icon';
import { ExitIcon } from '../appearance/icons/exit_icon';
import { LogoIcon } from '../appearance/icons/logo_icon';
import { ELSI_SHOP_URL, errorCallback, makeUrl, PAGE_MENU_ACCOUNTING, PAGE_MENU_CATALOG, PAGE_MENU_LIST, PAGE_MENU_SETUP} from '../const/const';
import { getFetchRequest, GET_CURRENT_USER, LOGOUT_REQUEST, postFetchRequest, MAKE_USER_REQUEST, SEARCH_PRODUCT_REQUESTS, PASSWORD_RESET_INFO } from '../store/requests';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { SearchHandler } from './sharedComponents/SearchHandler';
import { hintsService } from './sharedComponents/hintsService';
import { CustomReactRouter } from '../services/customRouter';
import { AccountingIcon, CatalogIcon, HomeIcon, OrdersIcon, RequestsIcon, SetupIcon } from '../appearance/icons/menu_icons';
import { cartService } from '../services/cartService';

// Импорт для menu-bottom
const ChevronIconSec = ({ nameOfClass }) => (
    <svg className={nameOfClass} width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1L8 8L15 1" stroke="#323232" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

// Иконка бургер-меню для мобильной версии
const BurgerMenuIcon = () => (
    <svg width="22" height="19" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1H22" stroke="#82838D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M1 9.31836H22" stroke="#82838D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M1 17.6357H11.9733" stroke="#82838D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

// Константы для menu-bottom
const PRODUCTS_PAGE = '/catalog';
const MANUFACTURERS_PAGE = '/manufacturers';

// Заглушка для CategoryListPopUp
const CategoryListPopUp = ({ setCategoriesListIsOpen }) => (
    <div className="categories-list-popup">
        <div className="categories-list-popup__content">
            <h3>Категории товаров</h3>
            <ul>
                <li>Категория 1</li>
                <li>Категория 2</li>
                <li>Категория 3</li>
            </ul>
        </div>
    </div>
);

// Новый компонент ExitButton
const ExitButton = ({ onLogout }) => (
    <div className="menu-common__exit navigation-link" onClick={onLogout}>
        <ExitIcon />
        <span className="menu-common__exit-text">Выход</span>
    </div>
);

// Простой компонент для мобильного меню
const MobileMenuPopUp = ({ isOpen, onClose, location, isVeryMobileScreen, dataIsLoad, managerName, ExitButtonComponent, MenuButtonsComponent }) => {
    const [activeClass, setActiveClass] = useState(false);
    const [visible, setVisible] = useState(false);
    const navigate = useNavigate();
    
    useEffect(() => {
        let timer;
        if (isOpen) {
            setVisible(true);
            timer = setTimeout(() => {
                setActiveClass(true);
            }, 50);
        } else {
            setActiveClass(false);
            timer = setTimeout(() => {
                setVisible(false);
            }, 300);
        }
        return () => {
            clearTimeout(timer);
        };
    }, [isOpen]);

    const handleClose = () => {
        setActiveClass(false);
        setTimeout(() => {
            onClose();
        }, 300);
    };

    const handleMenuItemClick = (path) => {
        navigate(path);
        handleClose();
    };

    if (!visible) return null;

    return (
        <div className={`mobile-menu-popup ${activeClass ? 'active' : ''}`}>
            <div className="mobile-menu-popup__backdrop" onClick={handleClose}></div>
            <div className="mobile-menu-popup__content">
                <nav className="mobile-menu-popup__nav">
                    {Object.values(PAGE_MENU_LIST).map((item, index) => {
                        let IconComponent = null;
                        switch(item.key) {
                        case 'home': IconComponent = HomeIcon; break;
                        case 'catalog': IconComponent = CatalogIcon; break;
                        case 'orders': IconComponent = OrdersIcon; break;
                        case 'requests': IconComponent = RequestsIcon; break;
                        case 'accounting': IconComponent = AccountingIcon; break;
                        case 'setup': IconComponent = SetupIcon; break;
                        default: IconComponent = null;
                        }
                        return (
                            <a
                                key={index}
                                href={`/${item.key}`}
                                className={`mobile-menu-item${location.pathname.includes(item.key) ? ' active' : ''}`}
                                onClick={e => {
                                    e.preventDefault();
                                    handleMenuItemClick(`/${item.key}`);
                                }}
                            >
                                {IconComponent && <IconComponent nameOfClass="menu__icon" style={{marginRight: '12px'}} />}
                                <div>
                                    <h3>{item.title}</h3>
                                    <p>{item.description || 'Раздел личного кабинета'}</p>
                                </div>
                            </a>
                        );
                    })}
                </nav>
                <p className="menu-common__manager-info">
                    {dataIsLoad?
                        <>
                            <span className="menu-common__manager-info-label">Ваш менеджер: {managerName}</span>
                            <span className="menu-common__manager-info-name">
                                <b>+7 (800) 775-02-42 доб. 101</b> <br />
                                101@auroraelec.ru</span>
                        </>:''}
                </p>
                {isVeryMobileScreen && (
                    <div className="mobile-menu-popup__user-container">
                        {MenuButtonsComponent}
                        {/* Кнопка выхода для очень мобильного экрана */}
                        {ExitButtonComponent}
                    </div>
                )}
                <div className="mobile-menu-popup__header">
                    <button className="mobile-menu-popup__close" onClick={handleClose}>
                        <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 1L1 5L5 9" stroke="#86868E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                </div>

                <div className="mobile-menu-popup__footer">© Copyright Aurora Electronics 2022-2025 </div>
            </div>
        </div>
    );
};

const getTitle = (activeKey) => {
    let result = '';
    if(activeKey) {        
        const preparedKey = activeKey.split('/')[1];
        Object.values(PAGE_MENU_LIST).forEach(it => it.key === preparedKey?result=it.title:'');
    }
    return result;
};

export const handleGetDefaultCustomer = (dataArray) => {
    let result = '';
    if(dataArray.length) {
        dataArray.forEach(it => it.isDefault? result=it.name:'');
    }
    return result;
}; 

// Фиксированное нижнее меню для мобильных устройств
const MobileBottomNavigation = ({ location }) => {
    return (
        <div className="mobile-bottom-nav">
            {Object.values(PAGE_MENU_LIST)
                .filter(item => item.key !== 'accounting')
                .map((item) => {
                    let IconComponent = null;
                    switch(item.key) {
                    case 'home': IconComponent = HomeIcon; break;
                    case 'catalog': IconComponent = CatalogIcon; break;
                    case 'orders': IconComponent = OrdersIcon; break;
                    case 'requests': IconComponent = RequestsIcon; break;
                    case 'setup': IconComponent = SetupIcon; break;
                    default: IconComponent = null;
                    }
                    const labelMap = {
                        home: 'Главная',
                        catalog: 'Каталог',
                        orders: 'Заказы',
                        requests: 'Запросы',
                        setup: 'Настройки',
                    };
                    return (
                        <Link
                            key={item.key}
                            to={`/${item.key}`}
                            className={`mobile-bottom-nav__item${location.pathname.includes(item.key) ? ' active' : ''}`}
                        >
                            {IconComponent && <IconComponent nameOfClass="menu__icon" />}
                            <span>{labelMap[item.key] || item.title}</span>
                        </Link>
                    );
                })}
        </div>
    );
};

// Удалён дублирующийся вариант MobileBottomNavigation с другой разметкой



const CartMenuButton = ({ count, onClick }) => (
    <button type="button" className="menu-middle__button" onClick={onClick} aria-label="Корзина">
        <span className="menu-middle__button-icon">{count}</span>
        <svg width="28" height="25" viewBox="0 0 28 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M24.3785 12.5134L26.8484 5.66114C26.8865 5.55563 26.8986 5.44249 26.8838 5.33128C26.869 5.22008 26.8277 5.11408 26.7634 5.02226C26.6992 4.93044 26.6138 4.8555 26.5145 4.80377C26.4152 4.75205 26.3049 4.72507 26.1931 4.72511H7.35646L7.09843 3.4102C6.96354 2.73167 6.5986 2.12086 6.06557 1.68151C5.53254 1.24217 4.86429 1.00136 4.1743 1H1.69656C1.5118 1 1.33462 1.07359 1.20397 1.20459C1.07333 1.33559 0.999939 1.51327 0.999939 1.69853C0.999939 1.88379 1.07333 2.06146 1.20397 2.19246C1.33462 2.32346 1.5118 2.39706 1.69656 2.39706H4.1743C4.542 2.39779 4.89808 2.52626 5.18197 2.76059C5.46586 2.99493 5.66001 3.32065 5.73138 3.68235L6.09864 5.5544C6.0989 5.55775 6.0989 5.56112 6.09864 5.56446L7.73486 13.9088C7.73486 13.9183 7.7382 13.9278 7.74043 13.9373L8.19463 16.2553C8.32922 16.9341 8.69414 17.5453 9.22734 17.9848C9.76054 18.4243 10.4291 18.665 11.1193 18.6661H23.6914C23.8761 18.6661 24.0533 18.5925 24.1839 18.4615C24.3146 18.3305 24.388 18.1528 24.388 17.9675C24.388 17.7823 24.3146 17.6046 24.1839 17.4736C24.0533 17.3426 23.8761 17.269 23.6914 17.269H11.1215C10.7533 17.269 10.3964 17.1409 10.1118 16.9065C9.82724 16.6721 9.6326 16.346 9.56112 15.9837L9.26742 14.4844H21.5725C22.1853 14.4839 22.7831 14.2945 23.285 13.942C23.7869 13.5894 24.1686 13.0907 24.3785 12.5134ZM8.99713 13.0885L7.63009 6.12217H25.2022L23.0683 12.0367C22.9567 12.344 22.7536 12.6095 22.4866 12.7973C22.2195 12.9851 21.9015 13.0862 21.5753 13.0868L8.99713 13.0885Z" fill="#666666" stroke="#666666" strokeWidth="0.3"></path>
            <path d="M12.0644 19.4131C11.538 19.413 11.0235 19.5694 10.5858 19.8625C10.1481 20.1557 9.80693 20.5724 9.60543 21.0599C9.40394 21.5475 9.35116 22.084 9.45378 22.6017C9.55639 23.1193 9.80979 23.5949 10.1819 23.9681C10.5541 24.3413 11.0282 24.5955 11.5444 24.6985C12.0607 24.8015 12.5957 24.7487 13.082 24.5468C13.5683 24.3448 13.9839 24.0028 14.2764 23.564C14.5688 23.1252 14.7249 22.6092 14.7249 22.0815C14.7241 21.3741 14.4436 20.6959 13.9449 20.1956C13.4461 19.6954 12.7698 19.414 12.0644 19.4131ZM12.0644 23.3528C11.8136 23.3529 11.5684 23.2784 11.3598 23.1388C11.1513 22.9992 10.9887 22.8007 10.8926 22.5684C10.7966 22.3361 10.7714 22.0804 10.8202 21.8338C10.8691 21.5871 10.9898 21.3606 11.1671 21.1827C11.3444 21.0048 11.5703 20.8837 11.8162 20.8346C12.0622 20.7855 12.3172 20.8107 12.5489 20.9069C12.7806 21.0031 12.9786 21.166 13.1179 21.3751C13.2573 21.5842 13.3316 21.83 13.3316 22.0815C13.3314 22.4185 13.1978 22.7416 12.9602 22.9799C12.7226 23.2182 12.4004 23.3523 12.0644 23.3528Z" fill="#666666" stroke="#666666" strokeWidth="0.3"></path>
            <path d="M20.5427 19.4131C20.0164 19.4133 19.502 19.57 19.0645 19.8633C18.6271 20.1567 18.2862 20.5735 18.0849 21.0611C17.8837 21.5487 17.8312 22.0852 17.934 22.6027C18.0368 23.1203 18.2903 23.5956 18.6625 23.9687C19.0347 24.3418 19.5089 24.5958 20.025 24.6987C20.5412 24.8015 21.0762 24.7486 21.5624 24.5466C22.0486 24.3446 22.4641 24.0026 22.7565 23.5638C23.0488 23.125 23.2049 22.6092 23.2049 22.0815C23.204 21.3738 22.9232 20.6955 22.4241 20.1952C21.925 19.695 21.2484 19.4137 20.5427 19.4131ZM20.5427 23.3528C20.292 23.3526 20.0469 23.2778 19.8386 23.138C19.6302 22.9982 19.4679 22.7995 19.3721 22.5672C19.2763 22.3349 19.2514 22.0793 19.3004 21.8328C19.3495 21.5862 19.4703 21.3598 19.6477 21.1821C19.825 21.0044 20.0509 20.8835 20.2968 20.8345C20.5428 20.7855 20.7976 20.8108 21.0292 20.907C21.2608 21.0033 21.4588 21.1662 21.598 21.3753C21.7373 21.5843 21.8116 21.8301 21.8116 22.0815C21.8112 22.4187 21.6773 22.742 21.4394 22.9803C21.2015 23.2187 20.879 23.3526 20.5427 23.3528Z" fill="#666666" stroke="#666666" strokeWidth="0.3"></path>
        </svg>
        <span>Корзина</span>
    </button>
);

const Header = ({setIsCollapsed, isCollapsed, defaultCustomer, setDefaultCustomer}) => {
    const [managerName, setManagerName] = useState('');
    const [userName, setUserName] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const [scroll, setScroll] = useState(0);
    const [dataIsLoad, setDataIsLoad] = useState(false);
    const router = useNavigate();
    const CustomRouter = new CustomReactRouter(router);

    // 🛒 Состояние для счетчика товаров в корзине
    const [cartItemsCount, setCartItemsCount] = useState(0);

    // Состояния для menu-bottom
    const [categoriesListIsOpen, setCategoriesListIsOpen] = useState(false);
    const [activeMenuBottomTab, setActiveMenuBottomTab] = useState('');
    const [isSmallScreen, setIsSmallScreen] = useState(false);
    const [isMobileScreen, setIsMobileScreen] = useState(false);
    const [mobileMenuIsOpen, setMobileMenuIsOpen] = useState(false);
    const [isVeryMobileScreen, setIsVeryMobileScreen] = useState(false);
    const [usdRate, setUsdRate] = useState(null);
    const [rateDate, setRateDate] = useState('');

    // Функция для получения курса USD от бэкенда (единый источник)
    const fetchUsdRate = async () => {
        try {
            const response = await fetch(makeUrl(['/api/v1/integration/currency/rate/']), { cache: 'no-store' });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            
            if (data && typeof data.rate === 'number' && data.rateDate) {
                setUsdRate(data.rate);
                setRateDate(data.rateDate);
            }
        } catch (error) {
            console.error('Ошибка при получении курса ЦБ:', error);
            // Устанавливаем fallback значения
            setUsdRate(95.0);
            setRateDate(new Date().toLocaleDateString('ru-RU', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                timeZone: 'Europe/Moscow',
            }));
        }
    };

    // Убираем состояние модального окна корзины

    // Добавляем эффект для блокировки скролла когда открыто меню
    useEffect(() => {
        if (mobileMenuIsOpen) {
            // Блокируем скролл
            document.body.style.overflow = 'hidden';
        } else {
            // Восстанавливаем скролл
            document.body.style.overflow = '';
        }
        
        // Очищаем при размонтировании
        return () => {
            document.body.style.overflow = '';
        };
    }, [mobileMenuIsOpen]);

    // Добавляем стили для анимации мобильного меню
    useEffect(() => {
        // Создаем стиль для анимации мобильного меню
        const styleElement = document.createElement('style');
        styleElement.textContent = `
            .mobile-menu-popup {
                transition: opacity 0.3s ease;
                opacity: 0;
            }
            
            .mobile-menu-popup.active {
                opacity: 1;
            }
            
            .mobile-menu-popup__content {
                transform: translateX(-100%);
                transition: transform 0.3s ease;
            }
            
            .mobile-menu-popup.active .mobile-menu-popup__content {
                transform: translateX(0);
            }
        `;
        document.head.appendChild(styleElement);
        
        return () => {
            document.head.removeChild(styleElement);
        };
    }, []);

    const handleScroll = () => {
        setScroll(window.scrollY);
        // Закрываем список категорий при прокрутке
        if(window.scrollY > 200) setCategoriesListIsOpen(false);
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // Проверка размера экрана - меняем на 600 пикселей
    useEffect(() => {
        const checkScreenSize = () => {
            setIsSmallScreen(window.innerWidth < 700);
            setIsMobileScreen(window.innerWidth < 1300);
            setIsVeryMobileScreen(window.innerWidth < 700);
        };
        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);
        return () => {
            window.removeEventListener('resize', checkScreenSize);
        };
    }, []);

    const succesGetUserInfoCallback = (result) => {
        setUserName(result.name || '');
        setDataIsLoad(true);
    };

    const errorGetUserDataCallback = (error) => {
        if (error.name === 'AbortError') {
            return null;
        } else {
            console.log(error);
        }
        setDataIsLoad(true);
    };

    const succesGetCurrentUserCallback = (response) => {
        if(response.id) {
            getFetchRequest(makeUrl([MAKE_USER_REQUEST, response.id, '/']), succesGetUserInfoCallback, errorGetUserDataCallback);
            handleGetManager(response.id);
            handleGetCustomerInfo(response.id);
        } else {
            // Фолбэк: если нет авторизации, но есть reset code, попробуем получить менеджера через password/info
            try {
                const url = new URL(window.location.href);
                const code = url.searchParams.get('code');
                const isSetup = url.pathname === '/setup' && !!code;
                if (isSetup) {
                    fetch(makeUrl([PASSWORD_RESET_INFO]), {
                        credentials: 'include',
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ code }),
                    }).then(async res => {
                        if (!res.ok) {
                            setDataIsLoad(true);
                            return;
                        }
                        const data = await res.json();
                        if (data && data.manager && data.manager.name) {
                            setManagerName(data.manager.name);
                        }
                        setDataIsLoad(true);
                    }).catch(() => setDataIsLoad(true));
                } else {
                    setDataIsLoad(true);
                }
            } catch (e) {
                setDataIsLoad(true);
            }
        }
    };

    const succesGetManagerInfoCallback = async (response) => {
        if(response.ok) {
            const result = await response.json();
            setManagerName(result.name);
        }
    };

    const succesGetCustomersListInfo = async (response) => {
        setDefaultCustomer(handleGetDefaultCustomer(response));
        await setDataIsLoad(true);
    };

    const errorGetDataCallback = (error) => {
        if (error.name === 'AbortError') {
            return null;
        } else {
            console.log(error);
        }
        setDataIsLoad(true);
    };

    useEffect(()=> {
        getFetchRequest(makeUrl([GET_CURRENT_USER]), succesGetCurrentUserCallback, errorGetDataCallback);
    },[]);

    // Загружаем курс USD при монтировании компонента и обновляем каждый час
    useEffect(() => {
        fetchUsdRate();
        
        // Обновляем курс каждый час (3600000 мс)
        const interval = setInterval(() => {
            fetchUsdRate();
        }, 3600000);

        return () => clearInterval(interval);
    }, []);

    // 🛒 Подписываемся на изменения корзины для обновления счетчика
    useEffect(() => {
        const handleCartUpdate = (cart) => {
            const itemsCount = cart?.products?.length || 0;
            console.log(`🛒 [Header] Cart updated: ${itemsCount} items`);
            setCartItemsCount(itemsCount);
        };

        // Подписываемся на изменения корзины
        cartService.subscribe(handleCartUpdate);

        // Получаем начальное состояние корзины
        cartService.getCurrentCartQuiet().then(cart => {
            const itemsCount = cart?.products?.length || 0;
            console.log(`🛒 [Header] Initial cart: ${itemsCount} items`);
            setCartItemsCount(itemsCount);
        }).catch(error => {
            console.error('🛒 [Header] Error loading initial cart:', error);
            setCartItemsCount(0);
        });

        // Отписываемся при размонтировании
        return () => {
            cartService.unsubscribe(handleCartUpdate);
        };
    }, []);

    const succesCallback = (response) => {
        if(response.status === 200) {
            localStorage.removeItem("token");
            window.location.href = `${ELSI_SHOP_URL}/login`;
        }
    };

    const handleGetManager = (userId) => {
        getFetchRequest(makeUrl([MAKE_USER_REQUEST, userId, '/manager/']), succesGetManagerInfoCallback, errorGetDataCallback, true);
    };

    const handleGetCustomerInfo = (userId) => {
        getFetchRequest(makeUrl([MAKE_USER_REQUEST, userId, '/customer/']), succesGetCustomersListInfo, errorCallback);
    };

    const handleLogout = () => {
        postFetchRequest(makeUrl([LOGOUT_REQUEST]), '', succesCallback, errorCallback, true);
    };

    const handleCloseSearchList = (e) => {
        e.stopPropagation();
        hintsService.clearHintsList();
    };

    // Обработчики для menu-bottom
    const handleClick = (e, url) => {
        e.preventDefault();
        setActiveMenuBottomTab(url);
        setCategoriesListIsOpen(false);
        navigate(url);
    };

    // Обработчик для кнопки бургер-меню
    const handleMenuButtonClick = (e) => {
        e.preventDefault();
        if (isMobileScreen) {
            // На мобильных открываем меню
            setMobileMenuIsOpen(!mobileMenuIsOpen);
        } else {
            // На десктопе обычное поведение
            handleClick(e, PRODUCTS_PAGE);
        }
    };

    // Обработчик для перехода на страницу корзины
    const handleCartIconClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        navigate('/cart');
    };

    return (
        <header className="header" onClick={handleCloseSearchList}>
            {/* Приводим верхнюю часть шапки к виду из магазина */}
            <div className="menu-middle container gg613380">
                <Link to='/home' className="menu-middle__logo navigation-link">
                    <LogoIcon />
                </Link>
                <div className="menu-middle__cbrf">
                    {usdRate ? 
                        <>
                            <span>Курс $ ЦБ на</span> {rateDate} <span>|</span> <p>{usdRate.toFixed(4)} Р</p>
                        </> :
                        'Загрузка курса...'
                    }
                </div>
                {/* Справа: бургер на очень маленьких экранах, кнопка вход/выход на остальных */}
                <div className="menu-middle__right">
                    <CartMenuButton count={cartItemsCount} onClick={handleCartIconClick} />
                    {isVeryMobileScreen ? (
                        <div className="menu-bottom__burger-btn" onClick={handleMenuButtonClick}>
                            <BurgerMenuIcon />
                        </div>
                    ) : (
                        <div className="menu-middle-button">
                            <a href="#" onClick={(e)=>{
                                e.preventDefault();
                                const url = new URL(window.location.href);
                                const code = url.searchParams.get('code');
                                const isSetup = url.pathname === '/setup' && !!code;
                                if (userName) {
                                    handleLogout();
                                } else if (isSetup) {
                                    window.location.href = 'https://auroraelec.ru/login';
                                } else {
                                    navigate('/login');
                                }
                            }} className="menu-middle__login navigation-link">
                                <p className="menu-middle__login-block">
                                    <span className="menu-middle__login-text">{userName?`Выход`:'Вход'}</span>
                                </p>
                                <svg className="menu-middle__login-icon" width="18" height="19" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.175 10.4033C13.1935 9.8242 13.9893 8.93072 14.4391 7.86141C14.8888 6.7921 14.9674 5.60671 14.6626 4.489C14.3579 3.3713 13.6867 2.38372 12.7533 1.67937C11.8199 0.975028 10.6764 0.593262 9.49995 0.593262C8.32354 0.593262 7.17998 0.975028 6.24657 1.67937C5.31316 2.38372 4.64204 3.3713 4.33726 4.489C4.03248 5.60671 4.11106 6.7921 4.56082 7.86141C5.01058 8.93072 5.80639 9.8242 6.82488 10.4033C3.16707 11.5263 0.50415 14.8898 0.50415 18.8531C0.50415 18.9998 0.56341 19.1406 0.668892 19.2443C0.774374 19.3481 0.917439 19.4064 1.06661 19.4064C1.21579 19.4064 1.35885 19.3481 1.46433 19.2443C1.56982 19.1406 1.62908 18.9998 1.62908 18.8531C1.62908 14.584 5.15999 11.1107 9.49995 11.1107C13.8399 11.1107 17.3708 14.584 17.3708 18.8531C17.3708 18.9998 17.4301 19.1406 17.5356 19.2443C17.6411 19.3481 17.7841 19.4064 17.9333 19.4064C18.0825 19.4064 18.2255 19.3481 18.331 19.2443C18.4365 19.1406 18.4958 18.9998 18.4958 18.8531C18.4958 14.8898 15.8328 11.5263 12.175 10.4033ZM5.27968 5.8527C5.27968 5.03163 5.5272 4.229 5.99093 3.54631C6.45466 2.86362 7.11377 2.33152 7.88493 2.01731C8.65608 1.7031 9.50463 1.62089 10.3233 1.78107C11.1419 1.94126 11.8939 2.33664 12.4841 2.91722C13.0744 3.4978 13.4763 4.23751 13.6391 5.0428C13.802 5.84809 13.7184 6.6828 13.399 7.44137C13.0796 8.19994 12.5386 8.8483 11.8446 9.30446C11.1506 9.76062 10.3346 10.0041 9.49995 10.0041C8.38103 10.0029 7.30828 9.56517 6.51709 8.78689C5.72589 8.0086 5.28087 6.95336 5.27968 5.8527Z" fill="#82838D" stroke="#82838D" strokeWidth="0.9"></path></svg>
                            </a>
                        </div>
                    )}
                </div>
            </div>
            
            <nav className={`menu-bottom container ${scroll>200?'menu-bottom_sticky':''}`} onMouseLeave={()=> setCategoriesListIsOpen(false)}>
                {/* Бургер в нижнем меню только для ширины 700-1300 (isMobileScreen без isVeryMobileScreen) */}
                {isMobileScreen && !isVeryMobileScreen && (
                    <div className="menu-bottom__burger-btn" onClick={handleMenuButtonClick}>
                        <BurgerMenuIcon />
                    </div>
                )}
                <CollapseIcon nameOfClass={`info__collapse-icon ${isCollapsed ? 'info__collapse-icon_collapsed' : 'info__collapse-icon_full-width'} navigation-link`} setIsCollapsed={setIsCollapsed}/>
                <h3 className={`info__page-title ${isCollapsed ? 'info__page-title_collapsed' : ''} navigation-link`} onClick={() => setIsCollapsed(!isCollapsed)}>{getTitle(location.pathname)}</h3>
                {!isSmallScreen && <SearchHandler CustomRouter={CustomRouter} isMobile={isMobileScreen} />}
            </nav>
            {/* Показываем поисковую строку ниже menu-bottom для isSmallScreen */}
            {isSmallScreen && (
                <div className="container search-container">
                    <SearchHandler CustomRouter={CustomRouter} isMobile={isMobileScreen} />
                </div>
            )}
            
            {/* Показываем мобильное меню */}
            <MobileMenuPopUp 
                isOpen={mobileMenuIsOpen} 
                onClose={() => setMobileMenuIsOpen(false)}
                location={location}
                isVeryMobileScreen={isVeryMobileScreen}
                dataIsLoad={dataIsLoad}
                managerName={managerName}
                ExitButtonComponent={
                    <div className="mobile-menu-popup__user-block" onClick={handleLogout}>
                        <ExitButton />
                        {userName && <span className="menu-middle__login-text">Выход</span>}
                    </div>
                }
                MenuButtonsComponent={
                    <div className="menu-middle__buttons">
                        <CartMenuButton count={cartItemsCount} onClick={handleCartIconClick} />
                    </div>
                }
            />
            {/* Добавляем нижнее мобильное меню только для мобильных устройств */}
            {isMobileScreen && <MobileBottomNavigation location={location} />}
        </header>
    );
};

export default Header;